import { render } from "./PivotFormats.vue?vue&type=template&id=7bfa3232&ts=true"
import script from "./PivotFormats.vue?vue&type=script&lang=ts"
export * from "./PivotFormats.vue?vue&type=script&lang=ts"

import "./PivotFormats.vue?vue&type=style&index=0&id=7bfa3232&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__